var ResourceProxyClass = (function () {
    function ResourceProxyClass() {
    }
    return ResourceProxyClass;
}());
//# sourceMappingURL=ResourceProxyClass.js.map